import mod from "-!./requestTab.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./requestTab.js?vue&type=script&lang=js&external"